import { useEffect } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import {
  chatbotUsageAtom_SUSPENDS,
  interfacesUsageAtom_SUSPENDS,
  numberOfUniqueTableNodesAtom,
  numberOfUniqueInterfaceNodesAtom,
  numberOfUniqueChatbotNodesAtom,
  tablesUsageAtom_SUSPENDS,
} from "@zapier/canvas-state";

export function useTabFocus() {
  const numberOfTableNodes = useAtomValue(numberOfUniqueTableNodesAtom);
  const numberOfInterfaceNodes = useAtomValue(numberOfUniqueInterfaceNodesAtom);
  const numberOfChatbotNodes = useAtomValue(numberOfUniqueChatbotNodesAtom);

  const refreshTablesUsage = useSetAtom(tablesUsageAtom_SUSPENDS);
  const refreshInterfacesUsage = useSetAtom(interfacesUsageAtom_SUSPENDS);
  const refreshChatbotsUsage = useSetAtom(chatbotUsageAtom_SUSPENDS);

  useEffect(() => {
    const handleFocus = () => {
      if (numberOfTableNodes > 0) {
        refreshTablesUsage();
      }

      if (numberOfInterfaceNodes > 0) {
        refreshInterfacesUsage();
      }

      if (numberOfChatbotNodes > 0) {
        refreshChatbotsUsage();
      }
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [
    numberOfTableNodes,
    numberOfInterfaceNodes,
    numberOfChatbotNodes,
    refreshTablesUsage,
    refreshInterfacesUsage,
    refreshChatbotsUsage,
  ]);
}
